import { RequestService } from "./RequestService";

export class StudentsService extends RequestService {

    constructor() {
        super('students');
    }

    getAll = (queryParams) => this.request('get', 'get-all-students', '', '', queryParams);
    getOne = (studentId, queryParams) => this.request('get', `get-student/${studentId}`, '', '', queryParams);
    create = (body) => this.request('post', 'create-student', '', body);
    update = (body) => this.request('patch', 'update-student', '', body);
    delete = (body) => this.request('delete', 'delete-student', '', body);
    addToSchedule = (body) => this.request('post', 'add-student-to-schedule', '', body);
    addToSticker = (body) => this.request('post', 'add-student-to-sticker', '', body);
    uploadFromXLS = (file, stickerId, userId, stickerType = 'schedule') => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('stickerId', stickerId);
        formData.append('userId', userId);
        formData.append('stickerType', stickerType);
        return this.request('post', 'upload-students-xls', '', formData, null, true);
    };
    checkConflicts = (queryParams) => this.request('get', 'check-conflicts', '', '', queryParams);

}


